/**
 * Ставки НДС, которые принимает кассовый агент (Kalmykov-Cash-Agent, docs/ATOL.md: `tax.type` драйвера ККТ 10.10.9). Ставка берётся
 * У ТОВАРА (в 1С она контролируется на товаре): нет ставки — товар в чек не попадает, исправляется это во вкладке «Настройка»
 * номенклатуры, а не в окне продажи.
 */
export const VAT_CODES = [
  'none',
  'vat0',
  'vat5',
  'vat7',
  'vat10',
  'vat20',
  'vat22',
  'vat105',
  'vat107',
  'vat110',
  'vat118',
  'vat120',
  'vat122',
] as const

export type VatCode = (typeof VAT_CODES)[number]

export function isVatCode(value: unknown): value is VatCode {
  return typeof value === 'string' && (VAT_CODES as readonly string[]).includes(value)
}

const LABELS: Readonly<Record<VatCode, string>> = {
  none: 'Без НДС',
  vat0: 'НДС 0 %',
  vat5: 'НДС 5 %',
  vat7: 'НДС 7 %',
  vat10: 'НДС 10 %',
  vat20: 'НДС 20 %',
  vat22: 'НДС 22 %',
  vat105: 'НДС 5/105',
  vat107: 'НДС 7/107',
  vat110: 'НДС 10/110',
  vat118: 'НДС 18/118',
  vat120: 'НДС 20/120',
  vat122: 'НДС 22/122',
}

export const vatLabel = (code: VatCode): string => LABELS[code]
